import { render, staticRenderFns } from "./manual.vue?vue&type=template&id=6f7ad40a&scoped=true&"
import script from "./manual.vue?vue&type=script&lang=ts&"
export * from "./manual.vue?vue&type=script&lang=ts&"
import style0 from "./manual.vue?vue&type=style&index=0&id=6f7ad40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ad40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
